/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { DASHBOARD_URL } from '../constant';
import { fetchWithAuth } from '../helper/makeAjaxRequest';

const [PENDING, FULLFILLED, REJECTED] = ['pending', 'fulfilled', 'rejected'];
export const initialState = {
  data: [],
  loading: false,
  error: false,
  status: false
};

// thunk middleware
export const fetchDashboardSiteLov = createAsyncThunk(
  'fetchDashboardSiteLov',
  async ({ userType, viewType }, { rejectWithValue }) => {
    try {
      const resp = await fetchWithAuth(
        `${DASHBOARD_URL}/sites/${userType}/${viewType}`
      );

      return resp.map((data) => ({ label: data, value: data }));
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const dashboardSiteLovSlice = createSlice({
  name: fetchDashboardSiteLov,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDashboardSiteLov.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.data = [];
      state.status = PENDING;
    });
    builder.addCase(fetchDashboardSiteLov.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = FULLFILLED;
    });
    builder.addCase(fetchDashboardSiteLov.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.status = REJECTED;
    });
  }
});

// selectors
export const dashboardSiteLovSelector = (state) =>
  state?.dashboardSiteLov?.data;
export const dashboardSiteLovIsLoadedSelector = (state) =>
  state?.dashboardSiteLov?.status === FULLFILLED;

export default dashboardSiteLovSlice.reducer;
